import { IconLayer, TextLayer } from '@deck.gl/layers';

import type { VereinaStop } from '@/types';
import type { PickingInfo } from '@deck.gl/core';

import {
  characterSet,
  DEPTH,
  HUD_PARAMETERS,
  MAPPINGS,
  TEXT_STYLE,
  VEREINA_BADGE_BG_LAYER,
  VEREINA_BADGE_BORDER_LAYER,
  VEREINA_BADGE_OFFSET,
  VEREINA_BADGE_TEXT_LAYER,
} from '@/utils/constants/map';
import { VEREINA_ATLAS } from '@/utils/helpers/train-simulation/get-atlases';

export const getVereinaDeckLayers = (
  vereinaData: VereinaStop[],
  onClick: (info: PickingInfo) => boolean | void
) => {
  if (!vereinaData?.length) {
    return [];
  }

  const getPosition = (d: VereinaStop): [number, number] => [d.geoPos.lon, d.geoPos.lat];

  const borderLayer = new IconLayer<VereinaStop>({
    id: VEREINA_BADGE_BORDER_LAYER,
    data: vereinaData,
    iconAtlas: VEREINA_ATLAS,
    iconMapping: MAPPINGS.VEREINA_BADGE,
    getIcon: () => 'marker',
    getPosition,
    getSize: 23,
    getColor: [255, 255, 255],
    getPixelOffset: VEREINA_BADGE_OFFSET,
    billboard: true,
    parameters: HUD_PARAMETERS,
    getPolygonOffset: (): [number, number] => [0, DEPTH.BADGE + 0.1],
    pickable: false,
  });

  const bgLayer = new IconLayer<VereinaStop>({
    id: VEREINA_BADGE_BG_LAYER,
    data: vereinaData,
    iconAtlas: VEREINA_ATLAS,
    iconMapping: MAPPINGS.VEREINA_BADGE,
    getIcon: () => 'marker',
    getPosition,
    getSize: 20,
    getColor: (d: VereinaStop) => d.waitingTime.bg,
    getPixelOffset: VEREINA_BADGE_OFFSET,
    billboard: true,
    parameters: HUD_PARAMETERS,
    getPolygonOffset: (): [number, number] => [0, DEPTH.BADGE],
    pickable: true,
    onClick,
  });

  const textLayer = new TextLayer<VereinaStop>({
    id: VEREINA_BADGE_TEXT_LAYER,
    data: vereinaData,
    getPosition,
    getText: (d: VereinaStop) => d.waitingTime.value,
    getColor: (d: VereinaStop) => d.waitingTime.fg,
    getSize: TEXT_STYLE.size,
    fontWeight: TEXT_STYLE.fontWeight,
    fontFamily: TEXT_STYLE.fontFamily,
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'center',
    getPixelOffset: VEREINA_BADGE_OFFSET,
    billboard: true,
    parameters: HUD_PARAMETERS,
    getPolygonOffset: (): [number, number] => [0, DEPTH.TEXT],
    pickable: false,
    characterSet: characterSet,
  });

  return [borderLayer, bgLayer, textLayer];
};
